const capitalize = (day) => day.charAt(0).toUpperCase() + day.slice(1);

export const getScheduleDays = (schedule) => {
  if (Array.isArray(schedule?.days) && schedule.days.length > 0) return schedule.days;
  if (typeof schedule?.dayOfWeek === 'string' && schedule.dayOfWeek) {
    return [schedule.dayOfWeek.toLowerCase()];
  }
  return [];
};

const formatTime12 = (time) => {
  const [h, m] = (time || '18:00').split(':').map(Number);
  const period = h >= 12 ? 'PM' : 'AM';
  const hour12 = ((h + 11) % 12) + 1;
  return `${hour12}:${String(m).padStart(2, '0')} ${period}`;
};

export const formatNextRun = (schedule) => {
  if (!schedule) return null;
  const time12 = formatTime12(schedule.time);
  if (schedule.kind === 'daily') return `Daily at ${time12}`;
  const dayLabels = getScheduleDays(schedule).map(capitalize);
  if (dayLabels.length === 0) return null;
  return `${dayLabels.join(', ')} at ${time12}`;
};

export const describeSchedule = (schedule) => {
  if (!schedule) return null;
  const time12 = formatTime12(schedule.time);
  if (schedule.kind === 'daily') return `Daily at ${time12}`;
  const dayLabels = getScheduleDays(schedule).map((d) => capitalize(d).slice(0, 3));
  if (dayLabels.length === 0) return `Weekly at ${time12} (no days selected)`;
  return `${dayLabels.join(', ')} at ${time12}`;
};
